import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/pages/NotFound'
import PageForChina from '@/pages/PageForChina'
import FrameWithBack from '@/pages/help/FrameWithBack'
import Privacy from '@/pages/help/Privacy_202411.vue'
import KidsPrivacy from '@/pages/help/KidsPrivacy_202411.vue'

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			name: 'NotFoundPage',
			component: NotFound
		},
		{
			path: '/cn', redirect: '/cn/faq'
		},
		{
			path: '/cn/:section',
			name: 'pageforchina',
			component: PageForChina,
			props: true
		},
        {
			path: '/cn/privacy/android',
			name: 'Privacy',
			component: Privacy,
		},
        {
			path: '/cn/privacy/kids',
			name: 'KidsPrivacy',
			component: KidsPrivacy,
		},
		{
			path: '/frame/:page',
			name: 'frame',
			component: FrameWithBack,
			props: true
		}
	],
})
